module.exports = __webpack_public_path__ + "img/standard-icon6.0131a5e.svg";